import { Text } from "@chakra-ui/react";
import React from "react";

function CustomText({
  text,
  cursor,
  size,
  weight,
  color,
  align,
  transform,
  onClick,
  family,
  lh,
  wrap,
  mt,
}: any) {
  return (
    <Text
      cursor={cursor || "default"}
      fontSize={size || "16px"}
      fontWeight={weight || "400"}
      color={color || "yess.neutral400"}
      textAlign={align || "left"}
      textTransform={transform || "none"}
      lineHeight={lh || "normal"}
      whiteSpace={wrap || "auto"}
      mt={mt}
      onClick={onClick}
    >
      <span className={family || "aeonik-regular"}>{text}</span>
    </Text>
  );
}

export default CustomText;
